<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8">
      <div class="col-xl-3 col-lg-6">
        <h2 v-text="companyName" style="color: white"></h2>
      </div>
      <div class="row">
        <div class="col-6">
          <el-date-picker class="w-100"
                          v-model="dateRange"
                          type="daterange"
                          range-separator="-"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          start-placeholder="Başlangıç Tarihi"
                          end-placeholder="Bitiş Tarihi">
          </el-date-picker>
        </div>
        <div class="col-6">
          <el-button type="secondary" size="large" class="is-plain"
                     @click="dateFilter">
            <span>Filtrele</span>
          </el-button>
        </div>
      </div>
      <!-- Card stats -->
      <div class="row mt-2" v-loading="loading">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam Başvuru"
                      cardBg="bg-vg-green"
                      :sub-title="allApplicantsCount"
                      icon="ni ni-active-40"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="İş Başvurusu"
                      cardBg="bg-vg-purple"
                      :sub-title="jobApplicantsCount"
                      icon="ni ni-chart-pie-35"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Staj Başvurusu"
                      cardBg="bg-vg-yellow"
                      :sub-title="internshipApplicantsCount"
                      icon="ni ni-money-coins"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Diğer Başvurular"
                      cardBg="bg-vg-blue"
                      :sub-title="otherApplicantsCount"
                      icon="ni ni-chart-bar-32"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>

      </div>
      <div class="row mt-2" v-loading="loading">

        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam iş ve staj başvuru sayısı"
                      cardBg="bg-vg-green"
                      :sub-title="+internshipApplicantsCount +  +jobApplicantsCount"
                      icon="ni ni-money-coins"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam İlan Sayı"
                      cardBg="bg-vg-purple"
                      :sub-title="allJobCount"
                      icon="ni ni-active-40"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam İş İlanı"
                      cardBg="bg-vg-yellow"
                      :sub-title="normalJobCount"
                      icon="ni ni-chart-bar-32"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam Staj İlanı"
                      cardBg="bg-vg-blue"
                      :sub-title="internshipJobCount"
                      icon="ni ni-chart-bar-32"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
      </div>
      <div class="row mt-2" v-loading="loading">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Diğer Tiplerde İlan Sayısı"
                      cardBg="bg-vg-green"
                      :sub-title="otherJobCount"
                      icon="ni ni-chart-bar-32"
                      class="mb-4 mb-xl-0">
          </stats-card>
        </div>
      </div>
    </base-header>
    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col-xl-12">
                <p>İlan Listesi</p>
                <div class="table-responsive" v-loading="loading">
                  <vue-good-table
                      :columns="companiesColumns"
                      :rows="companies"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                      enabled: true,
                      mode: 'records',
                      nextLabel: 'İleri',
                      prevLabel: 'Geri',
                      rowsPerPageLabel: 'Sayfa başı sonuç',
                      pageLabel: 'Sayfa', // for 'pages' mode
                      allLabel: 'Hepsi',
                      ofLabel:'İlan',
                      perPage:10
                    }"
                      styleClass="table table-bordered table-striped">
                    <!--                    <template slot="table-row" slot-scope="props">-->
                    <!--                      <el-button v-if="props.column.field == 'id'" class="mr-1" type="primary" size="mini" plain>Detay-->
                    <!--                      </el-button>-->
                    <!--                    </template>-->
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
      <!--Tables-->
      <!--End tables-->
    </div>
  </div>


</template>

<script>
// import * as axios from "axios";
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import Vue from 'vue';
import * as axios from "axios";

Vue.use(VueGoodTable);
export default {
  name: "CompanyStatistics",
  data() {
    return {
      allCompanyCount: '',
      allMembersCount: '',
      companyName: '',
      confirmCompanyCount: '',
      unConfirmCompanyCount: '',
      allMembers: '',
      allApplicantsCount: '',
      internshipApplicantsCount: '',
      jobApplicantsCount: '',
      allJobCount: '',
      internshipJobCount: '',
      normalJobCount: '',
      otherApplicantsCount: '',
      otherJobCount: '',
      activityApplicantsCount: '',
      companies: [],
      loading: false,
      currentPage: 1,
      currentPageSize: 1,
      dateRange: '',
      company_id: '',
      companiesColumns: [
        {
          label: 'Başlık',
          field: 'title',
          type: 'string',
          html: false,
          filterable: true,
        },
        {
          label: 'İlan Tipi',
          field: 'ilan_tipi',
          type: 'string',
          html: true,
          filterable: true,
        },
        {
          label: 'Başvuru Sayısı',
          field: 'count',
          type: 'string',
          html: false,
          filterable: true,
        }
      ],

    };
  },
  created() {
    this.company_id = this.$route.params.id;
    this.getLastCompanies();
  },
  methods: {
    dateFilter() {
      if (this.dateRange == '') {
        return 0;
      }
      this.getLastCompanies();
    },
    getLastCompanies() {
      this.loading = true;
      var start_date = '';
      var end_date = '';
      if (this.dateRange != '') {
        var dateArray = this.dateRange.toString().split(",");
        start_date = dateArray[0];
        end_date = dateArray[1]
      }

      axios.get("admin/company-dashboard?company_id=" + this.company_id + "&start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.loading = false;
        // basamak ayırma
        this.internshipApplicantsCount = response.data.count_data[0].job_type_11_application_count.toString();
        this.jobApplicantsCount = response.data.count_data[0].job_type_12_application_count.toString();
        this.allApplicantsCount = response.data.count_data[0].total_application_count.toString();
        this.allJobCount = response.data.count_data[0].total_job_count.toString();
        this.internshipJobCount = response.data.count_data[0].job_type_11_job_count.toString();
        this.normalJobCount = response.data.count_data[0].job_type_12_job_count.toString();
        this.otherJobCount = response.data.count_data[0].job_type_other_job_count.toString();
        this.otherApplicantsCount = response.data.count_data[0].job_type_other_application_count.toString();
        // this.activityApplicantsCount = response.data.count_data[7].count.toString();
        this.companyName = response.data.count_data[0].company_name.toString();
        this.companies = response.data.company_jobs;
      })
          .catch(error => {
            this.loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: error.response.data.join(' ')
            });
          });

    }
  }
}
</script>

<style scoped>

</style>